import { render, staticRenderFns } from "./DiagnosticHeader.vue?vue&type=template&id=74bb5173&scoped=true"
import script from "./DiagnosticHeader.vue?vue&type=script&lang=js"
export * from "./DiagnosticHeader.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticHeader.vue?vue&type=style&index=0&id=74bb5173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb5173",
  null
  
)

export default component.exports